import React, { useEffect, useState } from 'react';
import './blogPostPage.scss';
import { useParams } from 'react-router-dom';
import PagesHeroSection from '../../components/pagesHeroSection';
import { Container, Spinner } from 'react-bootstrap';

import { doc, getDoc } from 'firebase/firestore/lite';
import { db } from '../../firebase/firebase';
import emptyBlogImg from '../../assets/blog/no-blog-img.png';

const BlogPostPage = () => {
  const { blogTitle, lang } = useParams();

  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const docRef = doc(db, 'blogs', blogTitle);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setBlog(docSnap.data());
        } else {
          setError(true);
        }
      } catch (err) {
        console.error('Error fetching blog:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [blogTitle]);

  const title = blog?.title?.[lang] || blog?.title?.en || 'Blog';
  const description = blog?.description?.[lang] || blog?.description?.en || '';
  const heroImage = blog?.imgUrl || emptyBlogImg;

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
        <p className="mt-3">Loading article...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-5">
        <PagesHeroSection page="Blog Not Found" background={emptyBlogImg} />
        <Container className="py-5">
          <h1>Article Not Found</h1>
          <p>The blog article you are looking for does not exist.</p>
        </Container>
      </div>
    );
  }

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: title,
    description: description,
    image: heroImage,
    author: {
      '@type': 'Organization',
      name: 'Avagyan Law Firm',
    },
    publisher: {
      '@type': 'Organization',
      name: 'Avagyan Law Firm',
      logo: {
        '@type': 'ImageObject',
        url: 'https://avagyanlaw.com/logo.png',
      },
    },
    mainEntityOfPage: window.location.href,
  };

  return (
    <article className="blog-post-page">
      <script type="application/ld+json">{JSON.stringify(schema)}</script>

      <PagesHeroSection page={title} background={heroImage} />

      <Container className="py-5">
        <header className="blog-header">
          <h1>{title}</h1>
        </header>

        <section className="blog-body">
          <p className="blog-description">{description}</p>
        </section>
      </Container>
    </article>
  );
};

export default BlogPostPage;
